"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilEnrichmentConstants = void 0;
class SoilEnrichmentConstants {
    constructor() {
        this.emissionFactor = 3.66;
        this.emissionFactorUnit = "tCO2e"; // emission factor
    }
}
exports.SoilEnrichmentConstants = SoilEnrichmentConstants;
